import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export const ScrollToTop = () => {
  // We use the actual location
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
